if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.zoomCleanup = null;
      }

      hide() {
        this.zoomCleanup?.();
        this.zoomCleanup = null;
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.zoomCleanup?.();
        this.zoomCleanup = null;
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.toggle('active', element.getAttribute('data-media-id') === mediaId);
        });
        const activeMedia = this.querySelector('[data-media-id="' + mediaId + '"]');
        if (!activeMedia) return;
        const container = this.querySelector('[role="document"]');
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (window.matchMedia('(max-width: 749px)').matches && activeMedia.tagName === 'IMG') {
          container.scrollTop = 0;
          container.scrollLeft = 0;
          let scale = 1;
          let x = 0;
          let y = 0;
          let startScale = 1;
          let startDistance = 0;
          let startX = 0;
          let startY = 0;
          let baseX = 0;
          let baseY = 0;
          const distance = (a, b) => Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
          const apply = () => {
            const maxX = (scale - 1) * container.clientWidth / 2;
            const maxY = (scale - 1) * container.clientHeight / 2;
            x = Math.max(-maxX, Math.min(maxX, x));
            y = Math.max(-maxY, Math.min(maxY, y));
            activeMedia.style.transform = 'translate(' + x + 'px, ' + y + 'px) scale(' + scale + ')';
          };
          const onStart = (event) => {
            if (event.touches.length === 2) {
              startDistance = distance(event.touches[0], event.touches[1]);
              startScale = scale;
              baseX = x;
              baseY = y;
              startX = (event.touches[0].clientX + event.touches[1].clientX) / 2;
              startY = (event.touches[0].clientY + event.touches[1].clientY) / 2;
            } else if (event.touches.length === 1) {
              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
              baseX = x;
              baseY = y;
            }
          };
          const onMove = (event) => {
            if (event.touches.length === 2 && startDistance) {
              event.preventDefault();
              scale = Math.max(1, Math.min(4, startScale * distance(event.touches[0], event.touches[1]) / startDistance));
              x = baseX + ((event.touches[0].clientX + event.touches[1].clientX) / 2 - startX);
              y = baseY + ((event.touches[0].clientY + event.touches[1].clientY) / 2 - startY);
              apply();
            } else if (event.touches.length === 1 && scale > 1) {
              event.preventDefault();
              x = baseX + event.touches[0].clientX - startX;
              y = baseY + event.touches[0].clientY - startY;
              apply();
            }
          };
          const onEnd = (event) => {
            if (event.touches.length === 1) {
              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
              baseX = x;
              baseY = y;
            }
            if (scale <= 1) {
              scale = 1;
              x = 0;
              y = 0;
              apply();
            }
          };
          activeMedia.style.transform = '';
          activeMedia.addEventListener('touchstart', onStart, { passive: true });
          activeMedia.addEventListener('touchmove', onMove, { passive: false });
          activeMedia.addEventListener('touchend', onEnd, { passive: true });
          activeMedia.addEventListener('touchcancel', onEnd, { passive: true });
          this.zoomCleanup = () => {
            activeMedia.removeEventListener('touchstart', onStart);
            activeMedia.removeEventListener('touchmove', onMove);
            activeMedia.removeEventListener('touchend', onEnd);
            activeMedia.removeEventListener('touchcancel', onEnd);
            activeMedia.style.transform = '';
          };
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
